import React from 'react';

import PropTypes from 'prop-types';
import ReCAPTCHA from 'react-google-recaptcha';

import { RECAPTCHA_SITE_KEY } from '../../utils/constant';

const Captcha = ({ onChange, errors, touched }) => {
  return (
    <>
      <div
        style={{ position: 'relative' }}
        className={`input-container ${
          errors.recaptcha && touched.recaptcha ? 'error' : ''
        }`}
      >
        <ReCAPTCHA
          sitekey={RECAPTCHA_SITE_KEY}
          name="recaptcha"
          onChange={onChange}
        />
      </div>
    </>
  );
};

Captcha.propTypes = {
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.isRequired,
  touched: PropTypes.func.isRequired
};

export default Captcha;
